import ModalHeader from '@/components/modal/ModalHeader.tsx';
import React from 'react';
import Modal from '@/components/modal/Modal.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import {
  TextCustomFieldFormData,
  TextCustomFieldInputData,
  textCustomFieldSchema,
} from '@/features/dashboard/tourCustomFields/schemas/textCustomFieldSchema.ts';
import { tourCustomFieldsRoute } from '@/features/dashboard/tourCustomFields/routes/tourCustomFieldsRoute.ts';
import TextCustomFieldForm from '@/features/dashboard/tourCustomFields/components/TextCustomFieldForm.tsx';
import useUpdateCustomField from '@/features/dashboard/tourCustomFields/hooks/useUpdateCustomField.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import { TextCustomFieldDefinitionDto } from '@/features/dashboard/tourCustomFields/types/TextCustomFieldDefinitionDto.ts';

const TextCustomFieldAddModal = ({
  onClose,
  fieldDef,
}: {
  onClose: () => void;
  fieldDef: TextCustomFieldDefinitionDto;
}) => {
  const { tourId } = tourCustomFieldsRoute.useParams();
  const form = useForm<TextCustomFieldInputData>({
    resolver: debugZodResolver(textCustomFieldSchema),
    defaultValues: {
      type: FieldType.TEXT,
      fieldName: fieldDef.name,
      isFieldMandatory: fieldDef.required,
      hint: fieldDef.hint,
      placeholder: fieldDef.placeholder,
      isCharacterLimitEnabled:
        fieldDef.maxChars !== null && fieldDef.minChars !== undefined,
      maxChars: fieldDef.maxChars ?? undefined,
      minChars: fieldDef.minChars ?? undefined,
    },
  });

  const updateCustomField = useUpdateCustomField(tourId, fieldDef.id);

  const handleSubmit = (data: TextCustomFieldFormData) => {
    updateCustomField.mutate(data, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <Modal onClose={onClose} isDirty={form.formState.isDirty}>
      <ModalHeader title="Edytuj pole tekstowe" onClose={onClose} />
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <TextCustomFieldForm />
          <ModalFooter>
            <ActionButton tone="outline" size="sm" onClick={onClose}>
              Zamknij
            </ActionButton>
            <ActionButton tone="accent" size="sm" type="submit">
              Zapisz
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default TextCustomFieldAddModal;
